import LoadingBox from 'components/Common/Loading/LoadingBox'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import styled from 'styled-components'

const SkeletonWrapper = styled(Group)`
  width: 100%;
  padding: 0 ${rem(16)};
`

const HeaderSkeleton = styled(LoadingBox)`
  height: ${rem(24)};
  width: ${rem(280)};
  margin: 0 auto;
`

const TabsSkeleton = styled.div`
  display: flex;
  gap: ${rem(8)};
  justify-content: center;
  width: 100%;
`

const TabSkeleton = styled(LoadingBox)`
  height: ${rem(32)};
  width: ${rem(110)};
  border-radius: ${rem(16)};
`

const ContentSkeleton = styled.div`
  display: grid;
  gap: ${rem(12)};
  grid-template-columns: repeat(auto-fit, minmax(${rem(220)}, 1fr));
`

const ContentItemSkeleton = styled(LoadingBox)`
  height: ${rem(150)};
  width: 100%;
`

function CruiseWhenSelectSkeleton() {
  return <SkeletonWrapper direction="vertical" gap={12} data-testid="cruise-when-select-skeleton">
    <HeaderSkeleton />
    <TabsSkeleton>
      <TabSkeleton />
      <TabSkeleton />
      <TabSkeleton />
    </TabsSkeleton>

    <ContentSkeleton>
      <ContentItemSkeleton />
      <ContentItemSkeleton />
      <ContentItemSkeleton />
    </ContentSkeleton>
  </SkeletonWrapper>
}

export default CruiseWhenSelectSkeleton
